// Path: src/Screens/Booking/BookingConfirmed.jsx
import React, { useContext } from 'react';
import { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../../../assets/css/user/general/stripepage/successbooking/Successbooking.css';
import axios from 'axios';
import { useEffect } from "react";
import AppContext from '../../../../../context/AppContext';





// ── Confetti pieces (random positions, colors & sizes) ──
const CONFETTI = [
  { size: 10, left: 4, delay: 0, dur: 6, color: '#FDB714', shape: 'circle' },
  { size: 8, left: 9, delay: 1.2, dur: 7, color: '#15803d', shape: 'rect' },
  { size: 12, left: 16, delay: 0.4, dur: 5.5, color: '#7c3aed', shape: 'rect' },
  { size: 7, left: 23, delay: 2.5, dur: 8, color: '#FDB714', shape: 'circle' },
  { size: 11, left: 31, delay: 0.8, dur: 6.5, color: '#15803d', shape: 'rect' },
  { size: 9, left: 39, delay: 1.8, dur: 7.5, color: '#e6a800', shape: 'circle' },
  { size: 13, left: 47, delay: 0.2, dur: 6, color: '#7c3aed', shape: 'circle' },
  { size: 8, left: 55, delay: 3, dur: 9, color: '#FDB714', shape: 'rect' },
  { size: 10, left: 63, delay: 1, dur: 5.5, color: '#15803d', shape: 'circle' },
  { size: 12, left: 71, delay: 2.2, dur: 7, color: '#e6a800', shape: 'rect' },
  { size: 7, left: 79, delay: 0.6, dur: 6.5, color: '#7c3aed', shape: 'rect' },
  { size: 11, left: 87, delay: 1.6, dur: 8, color: '#FDB714', shape: 'circle' },
  { size: 9, left: 94, delay: 2.8, dur: 6, color: '#15803d', shape: 'rect' },
  { size: 8, left: 13, delay: 3.4, dur: 7, color: '#e6a800', shape: 'circle' },
  { size: 10, left: 67, delay: 0.9, dur: 5.8, color: '#7c3aed', shape: 'circle' },
];

const SuccessBooking = () => {
  const navigate = useNavigate();
 
  const { state } = useLocation();
  const { baseUrl, authToken } = useContext(AppContext);
  const [searchParams] = useSearchParams();

  const bookingSaved = useRef(false);

  // Falls back to demo data so the page still looks right if visited directly
  const booking = {
    id: state?.bookingId ?? 'BK-204871',
    equipment: state?.equipmentName ?? 'Mahindra 575 DI Tractor',
    date: state?.date ?? '24 June 2026',
    time: state?.time ?? '8:00 AM – 5:00 PM',
    total: state?.totalAmount ?? 'PKR 6,500',
  };
  // axios.get(`/payment-success/${booking.id}/confirmation-email`)
  //   .then(() => {
  //     console.log('Confirmation email sent successfully');
  //   })
  //   .catch((error) => { 
  //     console.error('Error sending confirmation email:', error);
  //   });
  //   useEffect(() => {

  // const bookingId = searchParams.get("booking_id");

  //  if (bookingId) {

  //    axios.get(
  //      `'http://localhost:3000/payment-success?booking_id=${bookingId}`
  //    );

  //  }

  // }, []);

  const [verifying, setVerifying] = useState(true);
  const [verifyFailed, setVerifyFailed] = useState(false);

  // ── Booking is verified against Stripe itself here ──
  // The booking already exists (it was created BEFORE the redirect to Stripe,
  // with payment status "pending"). We never trust "the browser landed on
  // this page" as proof of payment — we ask the backend to confirm with
  // Stripe using the session_id, and only then is the booking marked "paid".
  useEffect(() => {
    if (bookingSaved.current) return;
    bookingSaved.current = true;

    const sessionId = searchParams.get("session_id");
    const bookingId = searchParams.get("booking_id");

    if (!sessionId || !bookingId) {
      setVerifying(false);
      setVerifyFailed(true);
      return;
    }

    axios
      .post(
        `${baseUrl}/customer/payment/verifyStripePayment`,
        { session_id: sessionId, booking_id: bookingId },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        setVerifying(false);
        if (!res.data.success) {
          setVerifyFailed(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setVerifying(false);
        setVerifyFailed(true);
      });
  }, []);

  return (
    <div className="bc-page">

      {/* ── Floating decorative blobs ── */}
      <div className="bc-blob bc-blob-1" />
      <div className="bc-blob bc-blob-2" />
      <div className="bc-blob bc-blob-3" />

      {/* ── Confetti ── */}
      <div className="bc-confetti-container">
        {CONFETTI.map((c, i) => (
          <span
            key={i}
            className={`bc-confetti bc-confetti-${c.shape}`}
            style={{
              width: c.size,
              height: c.size,
              left: `${c.left}%`,
              background: c.color,
              animationDelay: `${c.delay}s`,
              animationDuration: `${c.dur}s`,
            }}
          />
        ))}
      </div>

      <Container className="bc-container">
        <Row className="align-items-center justify-content-center min-vh-100">

          {/* ── Left: Illustration side ── */}
          <Col lg={5} md={6} className="bc-illustration-col">
            <div className="bc-illustration-wrapper">
              <div className="bc-tractor-wrap">
                <svg viewBox="0 0 260 200" xmlns="http://www.w3.org/2000/svg" className="bc-tractor-svg">
                  {/* Ground */}
                  <ellipse cx="130" cy="185" rx="110" ry="8" fill="#f0f0f0" />

                  {/* Body */}
                  <rect x="60" y="90" width="110" height="65" rx="10" fill="#FDB714" />
                  <rect x="70" y="75" width="60" height="40" rx="8" fill="#FDB714" />

                  {/* Cabin glass */}
                  <rect x="75" y="80" width="50" height="28" rx="5" fill="#fff" opacity="0.6" />

                  {/* Hood */}
                  <rect x="155" y="105" width="40" height="30" rx="6" fill="#e6a800" />
                  <rect x="185" y="110" width="15" height="6" rx="3" fill="#c8920a" />

                  {/* Exhaust pipe */}
                  <rect x="188" y="88" width="7" height="22" rx="3" fill="#333" />
                  <ellipse cx="191" cy="87" rx="5" ry="3" fill="#555" />

                  {/* Big rear wheel */}
                  <circle cx="95" cy="158" r="32" fill="#222" />
                  <circle cx="95" cy="158" r="24" fill="#333" />
                  <circle cx="95" cy="158" r="10" fill="#FDB714" />
                  {[0, 45, 90, 135, 180, 225, 270, 315].map((deg, i) => (
                    <line key={i}
                      x1="95" y1="158"
                      x2={95 + 20 * Math.cos(deg * Math.PI / 180)}
                      y2={158 + 20 * Math.sin(deg * Math.PI / 180)}
                      stroke="#FDB714" strokeWidth="2.5" />
                  ))}

                  {/* Small front wheel */}
                  <circle cx="175" cy="163" r="18" fill="#222" />
                  <circle cx="175" cy="163" r="12" fill="#333" />
                  <circle cx="175" cy="163" r="5" fill="#FDB714" />
                  {[0, 60, 120, 180, 240, 300].map((deg, i) => (
                    <line key={i}
                      x1="175" y1="163"
                      x2={175 + 10 * Math.cos(deg * Math.PI / 180)}
                      y2={163 + 10 * Math.sin(deg * Math.PI / 180)}
                      stroke="#FDB714" strokeWidth="2" />
                  ))}

                  {/* Farmer character */}
                  <rect x="100" y="95" width="22" height="26" rx="4" fill="#4a90d9" />
                  <circle cx="111" cy="88" r="10" fill="#f5c5a3" />
                  <ellipse cx="111" cy="80" rx="13" ry="3" fill="#8B4513" />
                  <rect x="106" y="72" width="10" height="9" rx="2" fill="#8B4513" />
                  <circle cx="108" cy="87" r="1.5" fill="#333" />
                  <circle cx="114" cy="87" r="1.5" fill="#333" />
                  <ellipse cx="111" cy="92" rx="2.5" ry="2" fill="#c0392b" />

                  {/* Success checkmark badge */}
                  <g className="bc-check-badge">
                    <circle cx="205" cy="68" r="24" fill="#15803d" />
                    <circle cx="205" cy="68" r="24" fill="none" stroke="#ffffff" strokeWidth="3" />
                    <path d="M194 68 L202 76 L217 58" fill="none" stroke="#ffffff"
                      strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
                  </g>
                </svg>
              </div>
            </div>
          </Col>

          {/* ── Right: Content side ── */}
          <Col lg={5} md={6} className="bc-content-col">

            {/* Status badge */}
            <div className="bc-badge">
              <span className="bc-badge-dot" />
              {verifying
                ? "Confirming Payment..."
                : verifyFailed
                ? "Payment Could Not Be Confirmed"
                : "Booking Confirmed"}
            </div>

            {/* Heading */}
            <h1 className="bc-heading">
              {verifying
                ? "Just a moment —"
                : verifyFailed
                ? "We couldn't confirm this payment"
                : "You're All Set —"}<br />
              <span className="bc-heading-accent">
                {verifying
                  ? "Confirming with Stripe..."
                  : verifyFailed
                  ? "Please check your Booking History"
                  : "Have a Great Harvest!"}
              </span>
            </h1>

            {/* Subtext */}
            <p className="bc-subtext">
              {verifying
                ? "Please wait while we verify your payment with Stripe."
                : verifyFailed
                ? "If money was deducted, it will reflect once verified. Please check your booking history or contact support."
                : "Your booking has been confirmed and a copy of the receipt has been sent to your email."}
            </p>

            {/* Booking summary card */}
            <div className="bc-summary-card">
              <div className="bc-summary-row">
                <span className="bc-summary-label">Booking ID</span>
                <span className="bc-summary-value">{booking.id}</span>
              </div>
              <div className="bc-summary-row">
                <span className="bc-summary-label">Equipment</span>
                <span className="bc-summary-value">{booking.equipment}</span>
              </div>
              <div className="bc-summary-row">
                <span className="bc-summary-label">Date</span>
                <span className="bc-summary-value">{booking.date}</span>
              </div>
              <div className="bc-summary-row">
                <span className="bc-summary-label">Time</span>
                <span className="bc-summary-value">{booking.time}</span>
              </div>
              <div className="bc-summary-divider" />
              <div className="bc-summary-row bc-summary-total">
                <span className="bc-summary-label">Total Paid</span>
                <span className="bc-summary-value">{booking.total}</span>
              </div>
            </div>

            {/* CTA buttons */}
            <div className="bc-btn-group">
              <Button className="bc-primary-btn" onClick={() => navigate('/user/booking-history')}>
                View My Bookings
              </Button>
              <Button className="bc-secondary-btn" onClick={() => navigate('/')}>
                Back to Home
              </Button>
            </div>

          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SuccessBooking;